import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-544e7046")

_pushScopeId("data-v-544e7046")
const _hoisted_1 = { class: "patient-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "予約日時", -1)
const _hoisted_3 = { class: "patient-date" }
const _hoisted_4 = { class: "patient-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h3", null, "予約患者名", -1)
const _hoisted_6 = { class: "patient-name" }
const _hoisted_7 = { class: "patient-row" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", null, "担当医", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("先生 ")
const _hoisted_10 = { class: "patient-row" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h3", null, "予約時間", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("予約時間が重複しています")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_select_box = _resolveComponent("select-box")
  const _component_time_edit_box = _resolveComponent("time-edit-box")
  const _component_alert_message = _resolveComponent("alert-message")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.baseDateString), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.patientInfo), 1)
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_select_box, {
          title: "account",
          items: _ctx.accounts,
          modelValue: _ctx.selectedAccount,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedAccount = $event))
        }, {
          default: _withId(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["items", "modelValue"])
      ]),
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_time_edit_box, {
          class: "patient-time",
          placeholder: "開始時刻",
          modelValue: _ctx.startTime,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.startTime = $event)),
          interval: _ctx.appointmentTimeUnit
        }, null, 8, ["modelValue", "interval"]),
        _createVNode(_component_time_edit_box, {
          class: "patient-time",
          placeholder: "終了時刻",
          modelValue: _ctx.endTime,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.endTime = $event)),
          interval: _ctx.appointmentTimeUnit
        }, null, 8, ["modelValue", "interval"])
      ]),
      (_ctx.overlap)
        ? (_openBlock(), _createBlock(_component_alert_message, { key: 0 }, {
            default: _withId(() => [
              _hoisted_12
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})